import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { environment } from "src/environments/environment"

import { LoginResponse } from "../auth/models/login-response"
import { LoginRequest } from "../auth/models/login-request"
import { User } from "./models/user"

@Injectable()
export class AuthService {
	constructor(private http: HttpClient) {}

	public login(loginRequest: LoginRequest): Observable<LoginResponse> {
		return this.http.post<LoginResponse>(`${environment.DOMAIN_URL}/oauth/v2/token`, loginRequest)
	}

	public getUserInfo(): Observable<User> {
		return this.http.get<User>(`${environment.DOMAIN_URL}/api2/marketing/user/me`)
	}
}
